import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Slide, { SlideProps } from "@mui/material/Slide";

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

interface ToastSnackbarProps {
  isOpenToastMessage: boolean;
  handleCloseToastMessage: (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => void;
  toastMessage: string;
  severity: "error" | "warning" | "info" | "success";
  autoHideDuration?: number;
}

const ToastSnackbar: React.FC<ToastSnackbarProps> = ({
  isOpenToastMessage,
  handleCloseToastMessage,
  toastMessage,
  severity,
  autoHideDuration = 3000,
}) => {
  return (
    <Snackbar
      open={isOpenToastMessage}
      onClose={handleCloseToastMessage}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      autoHideDuration={autoHideDuration}
    >
      <Alert
        onClose={handleCloseToastMessage}
        severity={severity}
        variant="filled"
        sx={{
          width: "100%",
          direction: "ltr",
          position: "relative",
          bottom: "10px",

          "& .MuiAlert-root": {
            // backgroundColor: "#e63821",
            backgroundColor: "#ed2e78",
          },

          "& .MuiAlert-icon": {
            position: "relative",
            top: "4px",
          },

          "& .MuiAlert-message": {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            position: "relative",
            left: "5px",
            top: "2px",

            fontSize: "18px",
          },

          "& .MuiAlert-action": {
            position: "relative",
            top: "4px",
          },
        }}
      >
        {toastMessage}
      </Alert>
    </Snackbar>
  );
};

export default ToastSnackbar;
